export async function getSearchResult(lang, endpoint, query, activeTab, skip = 0, take = 12, sort = 'score') {

    let opts = {
        credentials: 'include',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': lang
        }
    };

    const r = await fetch(`${endpoint}/api/search?query=${query}&activeTab=${activeTab}&skip=${skip}&take=${take}&sort=${sort}`, opts);

    if (!r.ok) {
        throw new Error(`Search request failed: ${r.status}`);
    }

    const data = await r.json();
    return data;
}
export async function getMetaData(lang, endpoint, query) {

    let opts = {
        credentials: 'include',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': lang
        }
    };

    const r = await fetch(`${endpoint}/api/search/metadata?query=${query}`, opts);

    if (!r.ok) {
        throw new Error(`Search request failed: ${r.status}`);
    }

    const data = await r.json();
    return data;
}

export async function trackSearchEvent(lang, endpoint, query, hitId) {
    let opts = {
        credentials: 'include',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept-Language': lang
        }
    };

    await fetch(`${endpoint}/api/search/track?hitId=${hitId}&query=${query}`, opts);

}
